module.exports = __webpack_public_path__ + "img/b-icon-header-dark.c5e23fb1.svg";